import React from 'react';
import { Box } from '@fiverr-private/theme';
import { builderContentContainer } from './styles.ve.css';
import { BuilderStylesProviderProps } from './BuilderStylesProvider.types';

export const BuilderStylesProvider: React.FC<BuilderStylesProviderProps> = ({ children }) => (
  <Box className={builderContentContainer}>{children}</Box>
);
